// src/main.ts
import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import { createPinia } from 'pinia';
import { Badge, Button, Card, Calendar, Cell, CellGroup, Circle, ConfigProvider, DatePicker, Dialog, Field,Form, Icon, NavBar, NoticeBar, Picker, Popover, Popup, Progress, Search, Sidebar, SidebarItem, Stepper, Sticky, SubmitBar, Swipe, SwipeItem, Toast } from 'vant';
import 'vant/lib/index.css';
import { useLocalStorageStore } from '@/store/localStorageStore';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import MateChat from '@matechat/core';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(VCalendar);

const localStorageStore = useLocalStorageStore();
localStorageStore.init();

app.use(Badge);
app.use(Button);
app.use(Card);
app.use(Calendar);
app.use(Cell);
app.use(CellGroup);
app.use(Circle);
app.use(ConfigProvider);
app.use(DatePicker);
app.use(Dialog);
app.use(Field);
app.use(Form);
app.use(Icon);
app.use(NavBar);
app.use(NoticeBar);
app.use(Picker);
app.use(Popover);
app.use(Popup);
app.use(Progress);
app.use(Search);
app.use(Sidebar);
app.use(SidebarItem);
app.use(Stepper);
app.use(Sticky);
app.use(SubmitBar);
app.use(Swipe);
app.use(SwipeItem);
app.use(Toast);

app.use(MateChat);

app.mount('#app');